import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";

function Ourpractice(props) {
  return (
    <section className="tekgrip_section tekrevol_dark_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
            <div className="example" data-text="ERP Solutions">
              <h2>Our Custom Enterprise Software Development Process</h2>
            </div>
            <p>
              Being a premier ERP system company, we develop various ERP
              software modules designed to improve the efficiency of your
              workflows.
            </p>
            <p>
              Depending on the unique demands of your enterprise, we address
              specific facets such as financial management, inventory control,
              human resources, and customer relationship management. Here’s the
              structure we follow:
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekgrip_tabs"
          >
            <Tab.Container id="" defaultActiveKey="0">
              <Row>
                <Col xs={12} md={6} lg={6} xl={6}>
                  <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                      <Nav.Link eventKey="0">Plan</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="1">Build</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="2">Transform</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col xs={12} md={6} lg={6} xl={6} className="my-auto">
                  <Tab.Content>
                    <Tab.Pane eventKey="0">
                      <p>
                        We initiate the journey with a precise needs assessment,
                        diving into the complexities of your business. Our ERP
                        developers navigate through revenue models, growth
                        metrics, and visionary objectives to craft a customized
                        solution.
                      </p>
                      <p>
                        We then shape a personalized ERP implementation plan
                        customized to your unique requirements, ensuring a
                        strategic alignment with your organizational objectives.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="1">
                      <p>
                        The strategy and development roadmap are translated into
                        UI and UX by our creative designers. Our ERP developers
                        use the same details to create a robust front end and
                        backend.
                      </p>
                      <p>
                        Additionally, at this stage, we integrate APIs, connect
                        data centers, and link existing dashboards for a
                        seamless and integrated solution.
                      </p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="2">
                      <p>
                        After strict technical and experiential testing, our
                        deployment experts integrate the new ERP solutions and
                        features into existing business models. We establish
                        data collection and analysis measures and provide
                        support to internal stakeholders in managing access.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ourpractice;
